<template>
  <div>
    <el-row>
      <el-col :span="20">
    <el-form
      class="demo-ruleForm"
      label-position="left"
      label-width="90px"
      size="medium"
    >
      <el-form-item label="选择计划">
        <el-input
          v-model="selectScheduleName"
          placeholder="请输入计划单名称进行搜索"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <div class="form-collapse">
          <div class="form-collapse-title">计划单列表</div>
          <div class="form-collapse-content">
            <el-tree
            :props="props"
            :load="loadNode"
            v-loading="loading"
            :empty-text="emptyText"
            lazy
            node-key="index"
            :default-expanded-keys="treeExpandedData"
            :filter-node-method="filterNode"
            ref="tree"
            @node-click="handleNodeClick"
            icon-class="el-icon-arrow-right"
            class="form-tree"
            ></el-tree>
          </div>
        </div>
      </el-form-item>
    </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    planType: { type: Number, default: 0 }
  },
  data() {
    return {
      props: {
        label: 'label',
        orderId: 'orderId',
        orderName: 'orderName',
        scheduleName: 'scheduleName',
        index: 'index',
        scheduleId: 'scheduleId',
        partnerId: 'partnerId',
        spaceId: 'spaceId',
        spaceName: 'spaceName',
        isLeaf: 'leaf',
        children: 'children'
      },
      treeExpandedData: [],
      treeIndex: [],
      selectScheduleName: '',
      loading: false
    }
  },
  watch: {
  },
  computed: {
    emptyText() {
      let text = '加载中'
      if (this.loading !== true && this.treeExpandedData.length === 0) {
        text = '暂无数据'
      }
      return text
    }
  },
  methods: {
    handleSearch() {
      this.$refs.tree.filter(this.selectScheduleName)
    },
    loadNode(node, resolve) {
      this.loading = true
      if (node.level === 0) {
        this.$service.getAvailableOrder({ filter: 0, planType: this.planType }).then((data) => {
          let treeData = []
          if (data) {
            data.forEach((element, index) => {
              treeData.push({
                label: element.orderName,
                orderId: element.orderId,
                index: index,
                orderName: element.orderName,
                scheduleName: null,
                scheduleId: null,
                partnerId: element.partnerId,
                spaceId: null,
                spaceName: null,
                leaf: false,
                children: []
              })
              this.treeIndex.push(index)
            })
            this.loading = false
            resolve(treeData)
            const expandedData = this.cloneDeep(data.splice(0, 2)) || []
            expandedData.forEach((item, index) => {
              this.treeExpandedData.push(index)
            })
          } else {
            this.loading = false
            resolve([])
          }
        }).catch(() => {
          this.loading = false
        })
      } else {
        setTimeout(() => {
          this.$service.getScheduleByOrderId({ orderId: node.data.orderId, planType: this.planType }).then((data) => {
            let treeChildren = []
            if (data) {
              data.forEach((item, index) => {
                treeChildren.push({
                  label: item.scheduleName,
                  orderId: item.orderId,
                  index: this.treeIndex + index,
                  orderName: item.adOrder.orderName,
                  scheduleName: item.scheduleName,
                  scheduleId: item.scheduleId,
                  partnerId: item.adOrder.partnerId,
                  leaf: true,
                  spaceId: item.spaceId,
                  spaceNo: item.adSpace.spaceNo,
                  spaceName: item.adSpace.spaceName,
                  scheduleSource: item.scheduleSource,
                  supportMode: item.supportMode,
                  recId: item.scheduleSub ? item.scheduleSub.recId : undefined
                })
              })
              resolve(treeChildren)
              this.loading = false
            } else {
              this.loading = false
              resolve([])
            }
          }).catch(() => {
            this.loading = false
          })
        }, 500)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleNodeClick(data) {
      if (data.scheduleId && data.leaf) {
        this.selectScheduleName = data.label
        this.$emit('orderSchedule', data)
      }
    }
  },
  created() {
    // this.cities = citiList.rows
  }
}
</script>
<style lang="stylus" scoped>
.demo-ruleForm {
  margin-top: 10px;
  // max-width: 800px;
}

>>>.el-collapse {
  border-top: none;
}

>>>.el-collapse-item__header {
  flex-direction: row-reverse;
  justify-content: flex-end;
  height: 36px;
  line-height: 36px;
}

>>>.el-collapse-item__arrow {
  margin: 0 5px;
}

>>>.el-collapse-item__content {
  padding-bottom: 10px;
}

.form-collapse {
  border: 1px solid #dcdee6;
  border-radius: 4px;
}

.form-collapse-title {
  height: 36px;
  background: #f5f7fa;
  padding: 0px 10px;
  border-bottom: 1px solid #dcdde6;
}

.form-collapse-content {
  padding: 10px;
  max-height: 300px;
  overflow: auto;
}

.collapse-item-content {
  margin: 0px 18px;
  padding: 5px 0px;
  cursor: pointer;
}

.collapse-item-content:hover {
  cursor: pointer;
  color: #fc4c00;
}
.tree {
  >>>.el-tree-node__label {
      color rgba(0,0,0,0.85) !important
  }
}

</style>
